import React, { useState } from 'react';
import { Form, Input, Button, message, Typography } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import './TesterSignupForm.css';

const { Text } = Typography;

const TesterSignupForm = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values) => {
        setLoading(true);

        // Create mailto link with form data
        const subject = encodeURIComponent('BanYano Tester Sign Up');
        const body = encodeURIComponent(
            `Name: ${values.name}\nEmail: ${values.email}\n\nI'm interested in becoming a BanYano tester!`
        );
        const mailtoLink = `mailto:contact@banyano.app?subject=${subject}&body=${body}`;

        // Open email client
        window.location.href = mailtoLink;

        // Show success message
        message.success('Opening your email client. Thank you for your interest!');

        // Reset form
        form.resetFields();
        setLoading(false);
    };

    return (
        <div className="tester-signup-form">
            <Text strong style={{ fontSize: 18, display: 'block', marginBottom: 10 }}>
                Sign up as an early tester
            </Text>
            <Text style={{ fontSize: 14, display: 'block', marginBottom: 20, color: '#9ca3af' }}>
                Join our first testing phase on Android. We'll contact you when the app is ready for testing.
            </Text>

            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                autoComplete="off"
            >
                <Form.Item
                    name="name"
                    rules={[
                        { required: true, message: 'Please enter your name' },
                        { min: 2, message: 'Name must be at least 2 characters' }
                    ]}
                >
                    <Input
                        prefix={<UserOutlined style={{ color: '#6b7280' }} />}
                        placeholder="Your name"
                        size="large"
                    />
                </Form.Item>

                <Form.Item
                    name="email"
                    rules={[
                        { required: true, message: 'Please enter your email' },
                        { type: 'email', message: 'Please enter a valid email address' }
                    ]}
                >
                    <Input
                        prefix={<MailOutlined style={{ color: '#6b7280' }} />}
                        placeholder="your.email@example.com"
                        size="large"
                    />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={loading}
                        block
                        style={{
                            background: '#10b981',
                            borderColor: '#10b981',
                            fontWeight: 600,
                            height: 48
                        }}
                    >
                        Join the Waitlist
                    </Button>
                </Form.Item>
            </Form>

            {/* <Text style={{ fontSize: 12, display: 'block', marginTop: 15, color: '#6b7280', textAlign: 'center' }}>
                By signing up, you agree to receive updates about BanYano.
            </Text> */}
        </div>
    );
};

export default TesterSignupForm;
